import React from 'react'
import AppStoreDarkLargeSVG from '../icons/appStoreDarkLargeSVG'

const Pricing = ({ appStoreLink }) => {
  return (
    <section id="pricing">
      <div className="pt-4 md:pt-12 layout-space">
        <div className="max-w-6xl pb-12 mx-auto lg:px-10 md:pb-20 xl:pb-24">
          <div className="mb-12 md:text-center md:mb-16">
            <h2 className="mb-4 heading">Preismodell</h2>
            <p className="md:max-w-xl sub-heading md:mx-auto">
              Der Download von VoxRec ist KOSTENLOS. Unsere Aufnahme-Features sind komplett KOSTENLOS. Wir bieten monatliche Abonnements oder bedarfsgerechte Pay-per-Use-Preismodelle für die Sprache-zu-Text-Funktionalitäten.
            </p>
          </div>

          <div className="md:flex md:flex-row-reverse md:items-center">
            <div className="text-center md:flex md:flex-wrap md:text-left xl:w-3/5 md:w-1/2 md:items-start">
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-8">
                <h5 className="point-title">Wiedergabe-Hervorhebungen</h5>
                <p className="small">
                  Folgen Sie dem Sprecher und der Diskussion Wort für Wort mit visuellen Hervorhebungen während der Wiedergabe.
                </p>
              </div>
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-8">
                <h5 className="point-title">Formatieren &amp; Bearbeiten</h5>
                <p className="small">
                  Sie können Notizen zu Sprachaufnahmen hinzufügen, Transkripte bearbeiten sowie direkt auf Ihrem iPhone oder iPad Text formatieren und hervorheben.
                </p>
              </div>
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-0">
                <h5 className="point-title">Wichtige Stellen Markieren</h5>
                <p className="small">
                  Wenn es darauf ankommt, können Sie wichtige Stellen in einer Diskussion markieren. Kehren Sie zu den wichtigen Stellen mit nur einem Fingertipp zurück.
                </p>
              </div>
              <div className="max-w-sm px-4 mx-auto mb-12 md:w-1/2 md:mb-0">
                <h5 className="point-title">Backup &amp; Sync.</h5>
                <p className="small">
                  Dropbox, Google Drive oder iCloud. Ihre Sprachaufnahmen und Transkripte werden verlässlich gesichert.
                </p>
              </div>
            </div>
            <div className="md:w-1/2 xl:w-2/5 card-background-image">
              <div className="z-10 max-w-sm px-6 py-8 mx-auto bg-white shadow-lg md:mx-0 md:px-10 md:py-12 rounded-xl bg-10">
                <div className="mb-4">
                  <p className="from">ab</p>
                </div>
                <div className="flex items-end mb-4">
                  <h3 className="big-money">0,07€</h3>
                  <p className="mb-1 text-black md:text-3xl">
                    &nbsp;/&nbsp;Minute
                  </p>
                </div>
                <hr className="mb-2" />
                <h4 className="mb-6 text-accent">
                    30 Minuten KOSTENLOS{' '}
                  <span className="lg:hidden md:hidden text-accent">
                    Sprache zu Text
                  </span>
                </h4>
                <div className="md:justify-between md:flex md:items-center">
                  <a href={appStoreLink} target="_blank" rel="noreferrer">
                    <AppStoreDarkLargeSVG className="mb-4 app-store-link md:mb-0 md:mr-8" />
                  </a>
                  <p className="small">
                    Verfügbar für  iPhone, iPad, &amp; Apple Watch
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Pricing
